import { Outlet } from "react-router-dom";
import Navbar from "../components/Common/NavBar";
import { Footer } from "../components/Common/Footer";

const Layout = () => {
  return (
    <>
      <Navbar activeVisitorNavigation={true} />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
